import Config from '../config/constants';
import axios from 'axios';

/**
 * 카페24 연동 상태를 조회합니다.
 *
 * 🔴 이 화면이 있는 이유: 연동이 **3개월 끊겨 있었는데 아무도 몰랐다.**
 *    갱신 스케줄러 실패는 서버 로그에만 남고, 한 번 끊기면 **스스로 복구되지 않는다.**
 */
export const apiGetCafe24Health = async (accessToken: string): Promise<any> => {
  const url = `${Config.API_HOST}/api/admin/cafe24/health`;
  const response = await axios.get(url, { headers: { access_token: accessToken } });
  return response.data;
};
